import {
  gptDefineSlots,
  gptDisplayAds,
  gptSetTargeting,
  gptRefreshCallback,
  googleTagServerName,
  gptSetViewableEvents, gptSetRequestNonPersonalizedAds,
} from './googleTagProvider';
import { apstagFetchBids, apstagInit } from './apsTagProvider';
import { ErrorReporter } from '../errorReporter.type';
import { AdParams, AdSlots, AdSlotsConfiguration, AdSlotsConfigurationByPlatform, AdSlotsUnits } from './ads.types';

const setNonPersonalizedAds = (shouldNotPersonalizeAds: boolean) => {
  gptSetRequestNonPersonalizedAds(shouldNotPersonalizeAds);
};

const sendCustomParameters = (params: AdParams) => {
  gptSetTargeting(params);
};

const defineAdSlots = (adSlotsConfigurationByPlatform: AdSlotsConfigurationByPlatform, units: AdSlotsUnits, adsCategory: string) => {
  gptSetViewableEvents();
  gptDefineSlots(adSlotsConfigurationByPlatform, units, adsCategory);
};

const enableHeaderBidding = (adSlotsConfigurationByPlatform: AdSlotsConfigurationByPlatform, units: AdSlotsUnits, headerBidderPublisherID: string, errorProvider: ErrorReporter) => {
  apstagInit(headerBidderPublisherID, googleTagServerName, errorProvider);
  apstagFetchBids(adSlotsConfigurationByPlatform, units, gptRefreshCallback, errorProvider);
};

const displayAdSlots = (units: AdSlotsUnits) => {
  gptDisplayAds(units);
};

const getAdSlotsConfigurationByPlatform = (platform: string | undefined, adSlotsConf: AdSlotsConfiguration) => (platform === 'desktop' ? adSlotsConf.desktop : adSlotsConf.mobile);

export const initAds = (adSlots: AdSlots, params: AdParams, adsCategory: string, headerBidderPublisherID: string, shouldNotPersonalizeAds: boolean, errorProvider: ErrorReporter) => {
  defineAdSlots(getAdSlotsConfigurationByPlatform(params.platform, adSlots.conf), adSlots.units, adsCategory);
  setNonPersonalizedAds(shouldNotPersonalizeAds);
  sendCustomParameters(params);
  enableHeaderBidding(getAdSlotsConfigurationByPlatform(params.platform, adSlots.conf), adSlots.units, headerBidderPublisherID, errorProvider);
  displayAdSlots(adSlots.units);
};
